import { render, staticRenderFns } from "./CustomerAccountSites.vue?vue&type=template&id=7b128975&"
import script from "./CustomerAccountSites.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports